import { SizableText, YStack } from '@mythical/ui'
import { ButtonLink } from 'app/components/primitive/Button'
import { Meta } from 'app/components/primitive/Meta'
import { Container } from 'app/components/structure/Container'
import MainLayout from 'app/components/structure/Layout/MainLayout'
import { observer } from 'mobx-react-lite'

export const ContactScreen = observer(() => {
  return (
    <MainLayout noSidebar noSearch noFooter={false} showBackBtn>
      <Meta title="Contact" slug="contact" />
      <Container
        variant="medium"
        paddedX
        gap="$5"
        $gtSm={{ gap: '$8' }}
        pb="$6"
      >
        <SizableText
          tag="h1"
          ff="$heading"
          size="$xl"
          $gtSm={{ size: '$xxl' }}
          textTransform="uppercase"
          color="$fgPrimary"
          ta="center"
          maw={700}
          mx="auto"
        >
          Contact
        </SizableText>
        <YStack gap="$3" jc="center" ai="center">
          <SizableText ta="center" $gtSm={{ size: '$6' }}>
            Before you get in touch, have you checked out our FAQ page?
          </SizableText>
          <ButtonLink href="/pages/faqs" theme="primary">
            View FAQ
          </ButtonLink>
        </YStack>
        <YStack gap="$3" jc="center" ai="center">
          <SizableText ta="center" $gtSm={{ size: '$6' }}>
            Please submit any question you may have to the customer service
            portal below. You should receive a response within one to two
            business days.
          </SizableText>
          <ButtonLink
            target="_blank"
            href="https://contact.gorgias.help/forms/g2pecz0u"
          >
            Get in touch
          </ButtonLink>
        </YStack>
        <YStack jc="center" ai="center">
          <SizableText ta="center" $gtSm={{ size: '$6' }} fow="500" mb="$3">
            Want to send us some mail?
          </SizableText>
          <SizableText ta="center" size="$5">
            Rhett & Link c/o Mythical
          </SizableText>
          <SizableText ta="center" size="$5">
            ATTN: Mythical Society
          </SizableText>
          <SizableText ta="center" size="$5">
            P.O. Box 6578
          </SizableText>
          <SizableText ta="center" size="$5">
            Burbank, CA 91510
          </SizableText>
        </YStack>
      </Container>
    </MainLayout>
  )
})
